import { PhilatelicItemType } from '@briefmarken_katalog/types';

export const typeIndicatorClass: Record<PhilatelicItemType, string> = {
  [PhilatelicItemType.SingleStamp]: 'bg-blue-400',
  [PhilatelicItemType.Set]:         'bg-green-500',
  [PhilatelicItemType.StampFromSet]:'bg-green-500',
  [PhilatelicItemType.Block]:       'bg-amber-400',
  [PhilatelicItemType.Booklet]:     'bg-purple-400',
  [PhilatelicItemType.SeTenants]:   'bg-rose-400',
};

export const typeButtonClass: Record<PhilatelicItemType, string> = {
  [PhilatelicItemType.SingleStamp]: 'bg-blue-400   text-white border-blue-400   hover:bg-blue-500',
  [PhilatelicItemType.Set]:         'bg-green-500  text-white border-green-500  hover:bg-green-600',
  [PhilatelicItemType.StampFromSet]:'bg-green-500  text-white border-green-500  hover:bg-green-600',
  [PhilatelicItemType.Block]:       'bg-amber-400  text-white border-amber-400  hover:bg-amber-500',
  [PhilatelicItemType.Booklet]:     'bg-purple-400 text-white border-purple-400 hover:bg-purple-500',
  [PhilatelicItemType.SeTenants]:   'bg-rose-400   text-white border-rose-400   hover:bg-rose-500',
};
